export const COMMAND_NAME_TEST_ID = 'command-palette.ui.modal.body.command-name-container';
export const COMMAND_BREADCRUMB_TEST_ID =
	'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
export const COMMAND_BREADCRUMB_ITEM_TEST_ID =
	'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
export const COMMAND_BREADCRUMB_ITEM_SEPARATOR_TEST_ID =
	'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';
